export default "__VITE_ASSET__Ddj1hfkw__"